var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section empty-state"},[_c('p',{staticClass:"section-kicker"},[_vm._v("404")]),_c('h2',[_vm._v("页面不存在")]),_c('button',{staticClass:"primary-action compact",attrs:{"type":"button"},on:{"click":function($event){return _vm.front.goPath('/')}}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }